import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import { LoadingOverlay } from '../../../components/LoadingOverlay/LoadingOverlay';
import { Page } from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import getComms from './getComms.api';
import { Results } from './Results';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));

const CommsList = () => {
  const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(1);
  const commsData = getComms(rowsPerPage, page);
  const title = 'Communication List';
  return (
    <Page className={classes.root} title={title}>
      <PageHeader section="Communication" title={title} action={{
        permission: 'communication.create',
        route: '/comms/new',
        label: 'Add Communication',
      }}/>
      <LoadingOverlay loading={commsData.loading}>
        {!commsData.loading && commsData.data && commsData.data.communications.data && (
          <Results
            className={classes.results}
            data={commsData.data.communications.data}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            paginatorInfo={commsData.data.communications.paginatorInfo}
            setPage={setPage}
          />
        )}
      </LoadingOverlay>
    </Page>
  );
};

export default CommsList;
